export default __webpack_public_path__ + "static/media/TCLogoOnly.15710cf5.png";